export default __webpack_public_path__ + "static/media/psmedway-logo.f979fbb3.svg";